var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tabs',{staticStyle:{"background":"#fff"},attrs:{"type":"card"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"基本信息"}},[_c('base-info')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }